export enum APP_TYPE {
  IOS_PWA = 'pwa_ios',
  ANDROID_PWA = 'pwa_android',
  IOS_NATIVE = 'ios',
  ANDROID_NATIVE = 'android',
  EMULATION = 'emulation',
  BROWSER_MOBILE = 'browser_mobile',
  BROWSER_DESKTOP = 'browser_desktop',
}
